/* eslint-disable react/jsx-props-no-spreading */
import React, { createContext } from 'react';

export const ErrorBoundaryContext = createContext();
